import { Component, EventEmitter, Input, NgZone, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { EmployeeService } from '../../services/employees.service';
import { UtilService } from '../../services/util.service';
import {
    Group,
    SearchEmployeeGroupRoleMap
} from '../../models/models';

@Component({
    selector: 'employee-role-group-assign',
    templateUrl: './employee-role-group-assign.component.html',
    standalone: false
})
export class EmployeeRoleGroupAssign implements OnChanges {
    @Input() tableID: number = 0;
    @Input() tableHeader: string = "Employee Group";
    @Output() onRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public tableGrid!: GridComponent;

    public isAdd: boolean = false;

    public tableList: SearchEmployeeGroupRoleMap[] = [];
    public groupList: Group[] = [];
    public groupID: number = 0;

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: "lastName" }, { dir: 'asc', field: 'firstName' }] };

    constructor(private employeeService: EmployeeService, private utilService: UtilService, private dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getTableList();
    }

    private getGroups() {
        this.employeeService.getAllEmployeeGroups().subscribe(result => {
            this.groupList = [];
            var lst: Group[] = result;
            for (var i = 0; i < lst.length; i++) {
                var idx = this.tableList.findIndex(t => t.groupID == lst[i].groupId);
                if (idx < 0) {
                    this.groupList.push(lst[i]);
                }
            }
        });
    }

    private getTableList() {
        this.utilService.isLoading = true;
        this.employeeService.getSearchEmployeeGroupRoleMapsByEmployeeRoleID(this.tableID).subscribe(result => {
            this.utilService.isLoading = false;
            this.tableList = result.resultCollection;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.tableList = orderBy(this.tableList, this.gridState.sort);

        this.gridData = process(this.tableList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.tableGrid == null) return;
            this.tableGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public save() {
        this.employeeService.saveEmployeeGroupRoleMap(this.tableID, this.groupID).subscribe(result => {
            this.isAdd = false;
            this.getTableList();
        });
    }

    public delete(employeeGroupRoleMapID: number) {
        var idx = this.tableList.findIndex(c => c.employeeGroupRoleMapID == employeeGroupRoleMapID);

        if (idx == null || idx < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'Would you like to remove this group?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.employeeService.deleteEmployeeGroupRoleMap(employeeGroupRoleMapID).subscribe(result => {
                this.getTableList();
            });
        });
    }

    public addNew() {
        this.getGroups();
        this.isAdd = true;
    }

    public cancel() {
        this.isAdd = false;
        this.getTableList();
    }

    public close() {
        this.isAdd = false;
        this.onRefresh.emit();
    }
}
